// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2EUkO","logo":"Footer_logo__prC44","footerContent":"Footer_footerContent__2t0nQ","copyright":"Footer_copyright__2XrxV"};